import apiClient, { API_ENDPOINTS, dispatchAndResolve, rejectWithError } from "api";
import * as types from "./types.jsx";

const { invoice } = API_ENDPOINTS;

const rejectInvoiceError = (error, label) => rejectWithError(error, label);

export const createInvoice = (invoicePayload) => async (dispatch) => {
  try {
    const data = await apiClient.post(invoice.create, invoicePayload);
    return dispatchAndResolve(dispatch, types.CREATE_INVOICE, data);
  } catch (error) {
    return rejectInvoiceError(error, "Error creating invoice");
  }
};

export const updateInvoice = (invoicePayload) => async (dispatch) => {
  try {
    const data = await apiClient.post(invoice.update, invoicePayload);
    return dispatchAndResolve(dispatch, types.UPDATE_INVOICE, data);
  } catch (error) {
    return rejectInvoiceError(error, "Error updating invoice");
  }
};

export const getInvoiceById = (id) => async (dispatch) => {
  try {
    const data = await apiClient.get(invoice.getById, { pathParams: { id } });
    return dispatchAndResolve(dispatch, types.GET_INVOICE_BY_ID, data);
  } catch (error) {
    return rejectInvoiceError(error, "Error getting invoice by id");
  }
};

export const findInvoicesByCriteria = (criteria) => async (dispatch) => {
  try {
    const data = await apiClient.post(invoice.findByCriteria, criteria);
    return dispatchAndResolve(dispatch, types.FIND_INVOICES_BY_CRITERIA, data);
  } catch (error) {
    return rejectInvoiceError(error, "Error finding invoices by criteria");
  }
};
